import React, { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import { useRef } from 'react';
import CounselingAccordion from './CounselingAccordion';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import CounselingSecColSubChildUnRegister from './CounselingSecColSubChildUnRegister';
import CounselingSecColSubChild from './CounselingSecColSubChild';
import SubTypePopup from './SubTypePopup';
import AddSubValPopup from './AddSubValPopup';
import setUiMessage from '../../Utilities/Tostify';
import CopyFromLastVisitDropDown from '../../Utilities/CopyFromLastVisitDropDown';
import { handleCounsellingFormMidItem } from '../../httpdata/appointmentsdata';
import { setRenderFormData } from '../../redux/slices/Notes/counsellingNoteSlice';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../Button';
import { setAllDataTwo } from '../../redux/slices/patient/customCounsellingTwoSlice';
import AddCatagoryInCounsellingPopup from './AddCatagoryInCounsellingPopup';
import AddSubCatagoryInCounsellingPopup from './AddSubCatagoryInCounsellingPopup';

function CustomCounsellingTwoPopup({
  handleClose,
  patientId,
  soapId,
  appId,
  visitId,
  handleReload,
}) {
  // const [allData, setAllData] = useState(false);
  const [textAreaData, setTextAreaDataData] = useState({});
  const [checkBoxData, setCheckBoxData] = useState({});
  const [showHideChiled, setShowHideChiled] = useState('1_2');
  const [classFirstCol, setClassFirstCol] = useState('1_2');
  const [checkedAll, setCheckedAll] = useState({});
  const [childId, setChildId] = useState('');
  const [catAndId, setCatAndId] = useState('1_2');
  const [childSerch, setChildSerch] = useState({});
  const [accord, seAccord] = useState({});

  const [removeSubChild, setRemoveSubChild] = useState(false);
  const [sucPrams, setSucPrams] = useState('');
  const [subTypePopup, setSubTypePopup] = useState(false);
  const [subChildPrams, setSubChildPrams] = useState([]);
  const [addSubChild, setAddSubChild] = useState(false);
  const [editSubChild, setEditSubChild] = useState({
    status: false,
    data: null,
  });
  const [editSubValpopupData, setEditSubValPopupData] = useState(null);
  const [lastVisitData, setLastVisitData] = useState('');
  const [editModeEnabled, setEditModeEnabled] = useState(false);
  const [confirmEditableDialog, setConfirmEditableDialog] = useState(false);
  const [cancelLable, setCancelLable] = useState(false);
  const [cancelSubLable, setCancelSubLable] = useState(false);
  const [editCategoryData, setEditCategoryData] = useState({});
  const [addSubCategoryData, setAddSubCategoryData] = useState({});
  // const [editSubCategoryData, setEditSubCategoryData] = useState({});

  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { allDataTwo: allData } = useSelector(
    (store) => store.customCounsellingTwo,
  );
  const [confirmDelPopup, setConfirmDelPopup] = useState({
    status: false,
    id: '',
  });
  const [confirmSubDelPopup, setConfirmSubDelPopup] = useState({
    status: false,
    id: '',
  });

  const scrollRefs = useRef([]);
  const checkboxRef = useRef([]);

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/progressNote/customCounselingTwoPopup',
          {
            patientId: patientId,
            soapId: soapId,
            appId: appId,
            visitId: visitId,
          },
        );
        if (response.status === 200) {
          // setAllData(response?.data);
          dispatch(setAllDataTwo(response?.data));
          const formDatas = response?.data?.therapyMasterData?.reduce(
            (acc, data) => {
              data[2]?.forEach((subData) => {
                const key = `therapyDetailsText_${data[3]}_${subData[0]}`;
                acc[key] = subData[3];
              });
              return acc;
            },
            {},
          );

          const chkInptData = response?.data?.therapyMasterData?.reduce(
            (acc, data, i) => {
              data[2] &&
                data[2]?.forEach((subData, m) => {
                  if (m === 0 && i === 0) {
                    seAccord(data[3]);
                    setChildId(`${data[3]}_${subData[0]}`);
                    setShowHideChiled(`${data[3]}_${subData[0]}`);
                    setClassFirstCol(`${data[3]}_${subData[0]}`);
                  }

                  if (data[1] === 'Problem' && response?.data?.probArr) {
                    for (let f in response?.data?.probArr) {
                      const key = `ptcSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.probArr[f]?.dxId}`;

                      acc[key] = false;
                    }
                  } else if (
                    data[1] === 'Session' &&
                    response?.data?.golObjData
                  ) {
                    for (let f in response?.data?.golObjData) {
                      const key = `ptcSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.golObjData[f]?.goalId}`;

                      acc[key] = false;
                    }
                  } else {
                    subData[2] &&
                      subData[2]?.forEach((subChildData) => {
                        const key = `ptcSubChildDataListInpt_${data[3]}_${subData[0]}_${subChildData['child_id']}`;
                        acc[key] =
                          subChildData?.is_checked === '1' ? true : false;
                      });
                  }
                });
              return acc;
            },
            {},
          );

          setCheckBoxData(chkInptData);
          setTextAreaDataData(formDatas);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patientId, soapId, appId, visitId, dispatch]);

  const handleCounsellingFormSave = async () => {
    try {
      const response = await post(
        'api/patient/progressNote/saveCustomCounselingTwoForm',
        {
          patientId: patientId,
          soapId: soapId,
          appId: appId,
          visitId: visitId,
          staffUserId: user?.id,
          therapyDataJson: getCustomCounselingJson(),
        },
      );
      if (response.status === 200) {
        handleClose();
        handleReload('customCounsellingTwo');
        dispatch(
          setRenderFormData({
            data: {
              renderCustomCounselingTwoData:
                response.data.renderCustomCounselingTwoData,
            },
            type: 'customCounsellingTwo',
          }),
        );
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleCounsellingFormUpdate = async () => {
    try {
      const response = await post(
        'api/patient/progressNote/updateCustomCounselingTwoForm',
        {
          patientId: patientId,
          soapId: soapId,
          appId: appId,
          staffUserId: user?.id,
          therapyDataJson: getCustomCounselingJson(),
        },
      );
      if (response.status === 200) {
        handleClose();
        handleReload('customCounsellingTwo');
        dispatch(
          setRenderFormData({
            data: {
              renderCustomCounselingTwoData:
                response.data.renderCustomCounselingTwoData,
            },
            type: 'customCounsellingTwo',
          }),
        );
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const getCustomCounselingJson = () => {
    let masterArr = [];
    let hisAndSymMaster = document.querySelectorAll('.therapyAddEditSection');
    let retStr = false;
    if (hisAndSymMaster) {
      hisAndSymMaster.forEach(function (element) {
        const masterId = element.getAttribute('value');
        let masterText = document.querySelector(
          '#therapyDetailsText_' + masterId,
        ).value;

        let hisAndSymChield = document.querySelectorAll(
          '.ptcMasterSubChildData_' + masterId,
        );

        let childArr = [];
        hisAndSymChield.forEach(function (element, i) {
          let childIdTextArr = element.getAttribute('id').split('_');
          let subTypeVal = element.getAttribute('attr')
            ? element.getAttribute('attr')
            : '0';

          let childText = document.getElementById(
            'ptcSubChildDataList_' + masterId + '_' + childIdTextArr[3],
          ).textContent;

          childArr.push({
            masterId: masterId,
            childId: childIdTextArr[3],
            childText: childText.trim(),
            childInput: checkBoxData[element.getAttribute('id')] ? '1' : '0', //isChecked ? '1' : '0',
            childSubKey: subTypeVal,
          });
        });
        masterArr.push({
          masterId: masterId,
          masterText: masterText,
          childArr: childArr,
        });
      });
      retStr = JSON.stringify(masterArr);
    }
    return retStr;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTextAreaDataData({ ...textAreaData, [name]: value });
  };

  const handleSubTypePopup = (data) => {
    setSubTypePopup(true);
  };

  const handleCheckBoxLable = (eleId, data) => {
    if (data && parseInt(data?.sub_type) === 1) {
      handleSubTypePopup(data);
      setSubChildPrams([eleId, data]);
    } else {
      const target = checkboxRef.current[eleId];
      let checked = !target.checked;
      handleCheckBoxChangeComn(eleId, checked);
      setCheckBoxData({
        ...checkBoxData,
        [eleId]: checked ? true : false,
      });
    }
  };

  const handleCheckBoxChange = (e, data) => {
    const { id, checked } = e.target;
    if (checked && data && parseInt(data?.sub_type) === 1) {
      handleSubTypePopup(data);
      setSubChildPrams([e.target.id, data]);
      setCheckBoxData({
        ...checkBoxData,
        [e.target.id]: true,
      });
    } else {
      setCheckBoxData({
        ...checkBoxData,
        [id]: checked ? true : false,
      });
      handleCheckBoxChangeComn(id, checked);
    }
  };

  const handleCheckBoxChangeComn = (id, checked) => {
    const idArr = id?.split('_');

    let selStr = document?.querySelector(
      '#ptcSubChildDataList_' + idArr[1] + '_' + idArr[2] + '_' + idArr[3],
    ).textContent;

    let resSelStr = document?.querySelector(
      '#ptcdiagReason_' + idArr[1] + '_' + idArr[2] + '_' + idArr[3],
    ).textContent;

    if (resSelStr !== 'undefined') {
      selStr += resSelStr ? '\n' + resSelStr : '';
    }

    setChildId(idArr[1] + '_' + idArr[2]);
    let textData =
      textAreaData['therapyDetailsText_' + idArr[1] + '_' + idArr[2]];
    if (checked) {
      textData = textData?.replace(selStr, '');
      textData = textData?.replace(/^,*\s*|,*\s*$/, '');
      setTextAreaDataData({
        ...textAreaData,
        ['therapyDetailsText_' + idArr[1] + '_' + idArr[2]]: textData
          ? textData + '\n' + selStr
          : selStr,
      });
    } else {
      if (textData?.indexOf('\n' + selStr) === -1) {
        textData = textData?.replace(selStr + '\n', '');
      } else {
        textData = textData?.replace('\n' + selStr, '');
      }
      textData = textData?.replace(selStr, '');
      textData?.replace(/^,*\s*|,*\s*$/, '');

      setTextAreaDataData({
        ...textAreaData,
        ['therapyDetailsText_' + idArr[1] + '_' + idArr[2]]: textData,
      });
    }
  };

  useEffect(() => {
    if (childId) {
      let allChecked = true;
      const newObj = {};
      // const spl = childId?.split('_');
      for (const key in checkBoxData) {
        if (key.startsWith('ptcSubChildDataListInpt_' + childId + '_')) {
          newObj[key] = checkBoxData[key];
        }
      }
      for (const i in newObj) {
        if (newObj[i] === false) {
          allChecked = false;
        }
      }

      Object.keys(newObj).length !== 0 &&
        setCheckedAll((prevState) => ({
          ...prevState,
          [childId]: allChecked,
        }));
    }
  }, [checkBoxData, childId]);

  const handleSubDataShow = (id) => {
    setShowHideChiled(id);
    setClassFirstCol(id);
    setCatAndId(id);
    setChildId(id);
    const target = scrollRefs.current['therapyDetailsText_' + id];
    target.scrollIntoView({ behavior: 'smooth' });
  };

  const selectAll = (e, id) => {
    const { checked } = e.target;
    setCheckedAll({ ...checkedAll, [id]: checked ? true : false });

    let secColdata = document.querySelectorAll('.ptcMasterSubChildData_' + id);
    let finalText = '';
    secColdata.forEach(function (element, i) {
      let idArr = element.getAttribute('id').split('_');
      let selStr = document.getElementById(
        'ptcSubChildDataList_' + idArr[1] + '_' + idArr[2] + '_' + idArr[3],
      ).textContent;

      let resSelStr = document?.querySelector(
        '#ptcdiagReason_' + idArr[1] + '_' + idArr[2] + '_' + idArr[3],
      ).textContent;

      if (resSelStr !== 'undefined') {
        selStr += resSelStr ? '\n' + resSelStr : '';
      }

      if (checked) {
        checkBoxData[element.getAttribute('id')] = checked;
        finalText += selStr + '\n';
      } else {
        checkBoxData[element.getAttribute('id')] = checked;
      }
    });
    finalText = finalText.slice(0, -1);
    setTextAreaDataData({
      ...textAreaData,
      ['therapyDetailsText_' + id]: finalText,
    });
  };

  const handleChildSerch = (e, id) => {
    const { value } = e.target;
    setChildSerch({});
    setChildSerch({ ...childSerch, [id]: value });
  };

  useEffect(() => {
    let userInput = childSerch[catAndId]?.replace(/\\/g, '').toLowerCase();
    let secCol = document.querySelectorAll(
      '.ptcMasterSubChildData_' + catAndId,
    );
    secCol.forEach(function (element, i) {
      let searchTerm = element.getAttribute('data-search-term').toLowerCase();
      if (searchTerm.search(userInput) === -1) {
        element.classList.add('hide');
      } else {
        element.classList.remove('hide');
      }
    });
  }, [childSerch, catAndId]);

  const handleRemoveSubChild = (id) => {
    setRemoveSubChild(true);
    setSucPrams(id);
  };

  const handleEditSubChild = (id) => {
    setEditSubChild({ ...editSubChild, status: true, data: id });
  };

  const handleRemoveSubChildConfirm = async (id) => {
    const idArr = id.split('_');
    const itemId = idArr[2];
    if (itemId) {
      const response = await handleCounsellingFormMidItem(itemId, 'cctwo');
      if (response?.status === 200) {
        if (response.data.message === 'success') {
          setUiMessage('suc', 'Record deleted successfully.');
          setCheckBoxData({
            ...checkBoxData,
            ['ptcSubChildDataListInpt_' + id]: false,
          });
          const split = id?.split('_');
          const selStr = document?.querySelector(
            '#ptcSubChildDataList_' + id,
          ).innerHTML;

          setChildId(split[0] + '_' + split[1]);

          let textData =
            textAreaData['therapyDetailsText_' + split[0] + '_' + split[1]];

          if (textData?.indexOf('\n' + selStr) === -1) {
            textData = textData?.replace(selStr + '\n', '');
          } else {
            textData = textData?.replace('\n' + selStr, '');
          }

          //textData = textData?.replace(selStr, '');
          textData?.replace(/^,*\s*|,*\s*$/, '');
          setTextAreaDataData({
            ...textAreaData,
            ['therapyDetailsText_' + split[0] + '_' + split[1]]: textData,
          });

          const element = document.querySelector(
            '#ptcSubChildDataListInpt_' + id,
          );
          element.remove();
          setRemoveSubChild(false);
        }
      } else {
        setUiMessage('err', 'Something went wrong.');
      }
    }
  };

  const handlesubtypeform = (id, data) => {
    const idArr = id?.split('_');
    let textData =
      textAreaData['therapyDetailsText_' + idArr[1] + '_' + idArr[2]];
    //if (checked) {
    textData = textData?.replace(data, '');
    textData = textData?.replace(/^,*\s*|,*\s*$/, '');
    setTextAreaDataData({
      ...textAreaData,
      ['therapyDetailsText_' + idArr[1] + '_' + idArr[2]]: textData
        ? textData + '\n' + data
        : data,
    });
    //}

    setCheckBoxData({
      ...checkBoxData,
      [id]: true,
    });
  };

  // const handleCalbackData = (data, catagory, i, j, subTypeSection, mode) => {
  //   setCheckBoxData({
  //     ...checkBoxData,
  //     [`consultSubChildDataListInpt_${data[0]}_${data[1]}_${data[2]}`]: false,
  //   });

  //   const updatedData = [...allData?.therapyMasterData];

  //   if (mode === 'add') {
  //     const newObj = {
  //       child_id: data[2],
  //       child_texte: catagory,
  //       sub_type: subTypeSection ? '1' : '0',
  //     };
  //     if (updatedData[i][2][j][2]) {
  //       updatedData[i][2][j][2].push(newObj);
  //     } else {
  //       updatedData[i][2][j][2] = [newObj];
  //     }
  //   } else {
  //     const newObjIndex = updatedData[i][2][j][2].findIndex(
  //       (obj) => obj.child_id === data[2]
  //     );
  //     if (newObjIndex !== -1) {
  //       updatedData[i][2][j][2][newObjIndex].child_texte = catagory;
  //       updatedData[i][2][j][2][newObjIndex].sub_type = subTypeSection
  //         ? '1'
  //         : '0';
  //       // You can update other properties as well
  //     }
  //   }
  //   //setAllData(updatedData);
  // };

  const handleCalbackData = (data, catagory, i, j, subTypeSection, mode) => {
    setCheckBoxData((prev) => ({
      ...prev,
      [`consultSubChildDataListInpt_${data[0]}_${data[1]}_${data[2]}`]: false,
    }));

    const updatedData = structuredClone(allData?.therapyMasterData || []);

    if (!updatedData[i]?.[2]?.[j]) return;

    if (!Array.isArray(updatedData[i][2][j][2])) {
      updatedData[i][2][j][2] = [];
    }

    if (mode === 'add') {
      // Optional: prevent duplicate insert
      const exists = updatedData[i][2][j][2].some(
        (obj) => obj.child_id === data[2],
      );

      if (!exists) {
        updatedData[i][2][j][2].push({
          child_id: data[2],
          child_texte: catagory,
          sub_type: subTypeSection ? '1' : '0',
        });
      }
    } else {
      const index = updatedData[i][2][j][2].findIndex(
        (obj) => obj.child_id === data[2],
      );

      if (index !== -1) {
        updatedData[i][2][j][2][index] = {
          ...updatedData[i][2][j][2][index],
          child_texte: catagory,
          sub_type: subTypeSection ? '1' : '0',
        };
      }
    }

    dispatch(
      setAllDataTwo({
        ...allData,
        therapyMasterData: updatedData,
      }),
    );
  };

  const handleReStoreLastVisitData = (data) => {
    setLastVisitData(data);
    let args = data.split('_');
    (async () => {
      try {
        const response = await post(
          'api/patient/progressNote/customCounselingTwoPopup',
          {
            patientId: patientId,
            appId: args[1],
            visitId: args[2],
            soapId: args[0],
          },
        );
        if (response.status === 200) {
          dispatch(
            setAllDataTwo({
              ...allData,
              lastVisArr: response?.data?.lastVisArr,
              soapDetail: response?.data?.soapDetail,
              therapyMasterData: response?.data?.therapyMasterData,
            }),
          );
          // setAllData((lastData) => ({
          //   ...lastData,
          //   lastVisArr: response?.data?.lastVisArr,
          //   //probArr: response?.data?.probArr,
          //   soapDetail: response?.data?.soapDetail,
          //   therapyMasterData: response?.data?.therapyMasterData,
          // }));

          const formDatas = response?.data?.therapyMasterData?.reduce(
            (acc, data) => {
              data[2]?.forEach((subData) => {
                const key = `therapyDetailsText_${data[3]}_${subData[0]}`;
                acc[key] = subData[3] || '';
              });
              return acc;
            },
            {},
          );
          const chkInptData = response?.data?.therapyMasterData?.reduce(
            (acc, data, i) => {
              data[2] &&
                data[2]?.forEach((subData, m) => {
                  if (m === 0 && i === 0) {
                    seAccord(data[3]);
                    setChildId(`${data[3]}_${subData[0]}`);
                    setShowHideChiled(`${data[3]}_${subData[0]}`);
                    setClassFirstCol(`${data[3]}_${subData[0]}`);
                  }

                  if (data[1] === 'Problem' && response?.data?.probArr) {
                    for (let f in response?.data?.probArr) {
                      const key = `ptcSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.probArr[f]?.dxId}`;

                      acc[key] = false;
                    }
                  } else if (
                    data[1] === 'Session' &&
                    response?.data?.golObjData
                  ) {
                    for (let f in response?.data?.golObjData) {
                      const key = `ptcSubChildDataListInpt_${data[3]}_${subData[0]}_${response?.data?.golObjData[f]?.goalId}`;

                      acc[key] = false;
                    }
                  } else {
                    subData[2] &&
                      subData[2]?.forEach((subChildData) => {
                        const key = `ptcSubChildDataListInpt_${data[3]}_${subData[0]}_${subChildData['child_id']}`;
                        acc[key] =
                          subChildData?.is_checked === '1' ? true : false;
                      });
                  }
                });
              return acc;
            },
            {},
          );

          setCheckBoxData(chkInptData);
          setTextAreaDataData(formDatas);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  };

  const handleCloseFun = (type) => {
    if (type === 'silent') {
      handleClose();
      return;
    }
    if (allData?.mode === 'add') {
      handleCounsellingFormSave();
    } else if (allData?.mode === 'update') {
      handleCounsellingFormUpdate();
    }
  };

  const handleDeleteCategoryConfirm = async () => {
    try {
      const response = await post('api/patient/progressNote/deleteLableName', {
        id: confirmDelPopup.id,
        type: '5',
        staffUserId: user?.id,
      });
      if (response.status === 200) {
        dispatch(
          setAllDataTwo({
            ...allData,
            therapyMasterData: allData?.therapyMasterData?.filter(
              (item) => item[0] !== confirmDelPopup.id,
            ),
          }),
        );
        setCancelLable(false);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  const handleDeleteSubCategoryConfirm = async () => {
    try {
      const response = await post(
        'api/patient/progressNote/deleteSubLableName',
        {
          id: confirmSubDelPopup.id,
          type: '5',
          staffUserId: user?.id,
        },
      );
      if (response.status === 200) {
        dispatch(
          setAllDataTwo({
            ...allData,
            therapyMasterData: allData?.therapyMasterData?.map((category) => {
              if (Array.isArray(category[2])) {
                return [
                  ...category.slice(0, 2),
                  category[2].filter((sub) => sub[0] !== confirmSubDelPopup.id),
                  ...category.slice(3),
                ];
              }
              return category;
            }),
          }),
        );
        setCancelLable(false);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  return (
    <div className="modalBackground">
      <div className="main-contnr mat-cnslng-fu-con center-popup">
        <div className="main-contnr-hdr flex-sec">
          <div className="hdr-pt-info">
            <span className="black-txt clear-right10">Counseling:</span>
            {allData?.patientName}
            <span className="red"> | </span>
            ID: {allData?.chartNo}
            <span className="red"> | </span>
            {allData?.age} yrs-[{allData?.gender?.substr(0, 1)}]
            <span className="red"> | </span>
            DOB:{allData?.dob}
          </div>
          <div className="hdr-pt-info" style={{ width: '8%' }}>
            {editModeEnabled && (
              <Button
                variant="success"
                onClick={() => {
                  setEditModeEnabled(false);
                }}
              >
                Done
              </Button>
            )}
            {!editModeEnabled && (
              <Button
                variant="success"
                onClick={() => {
                  setConfirmEditableDialog(true);
                }}
              >
                Change
              </Button>
            )}
          </div>
          {!editModeEnabled && (
            <div className="hdr-pt-info" style={{ width: '24%' }}>
              <CopyFromLastVisitDropDown
                dataArr={allData}
                selectedVal={lastVisitData}
                calback={(selectedOption) =>
                  handleReStoreLastVisitData(selectedOption?.value)
                }
              />
              {/* <select
              className="book-appt-dd"
              value={lastVisitData}
              onChange={(e) => handleReStoreLastVisitData(e.target.value)}
            >
              <option value="">{''}</option>
              {allData?.lastVisArr?.map((data, i) => (
                <option
                  key={i}
                  value={`${data?.soapId}_${data?.appointment_id}_${data?.visitId}`}
                >
                  {`${data?.consultDate} - ${data?.resName.substr(0, 6)}...`}
                </option>
              ))}
            </select> */}
            </div>
          )}
          <Button variant="circle" onClick={() => handleCloseFun('silent')}>
            X
          </Button>
        </div>
        <div className="main-contnr-bdy mat-cnslng-fu-bdy flex-sec">
          <div className="mat-cnslng-col1">
            {editModeEnabled && (
              <div className="thrnst-nw-cnslng asmnt-ptnt-demo">
                <span
                  title="Add category"
                  className="cstm-add-cat-btn cursor showTemplate"
                  onClick={() => setCancelLable(true)}
                >
                  Add Category
                </span>
              </div>
            )}
            {allData?.therapyMasterData?.map((data, r) => (
              <CounselingAccordion
                key={r}
                classFirstCol={classFirstCol}
                accord={accord}
                handleSubDataShow={handleSubDataShow}
                parent={data}
                handleClick={(id) => {
                  if (data[2].length > 0) {
                    seAccord(data[3]);
                    handleSubDataShow(data[3] + '_' + data[2][0][0]);
                  }
                }}
                moduleName={'therapyAddEditSection'}
                editCategory={(data) => {
                  setCancelLable(true);
                  setEditCategoryData(data);
                }}
                handleDeleteCategory={(id) =>
                  setConfirmDelPopup({ status: true, id: id })
                }
                handleAddSubCategory={(data) => {
                  setCancelSubLable(true);
                  setAddSubCategoryData(data);
                }}
                handleEditSubCategory={(data) => {
                  setCancelSubLable(true);
                  setAddSubCategoryData(data);
                }}
                handleDeleteSubCategory={(id) =>
                  setConfirmSubDelPopup({ status: true, id: id })
                }
                editModeEnabled={editModeEnabled}
              />
            ))}
          </div>
          <div className="mat-cnslng-col2">
            {allData?.therapyMasterData?.map((data, i) => (
              <div key={i}>
                {data[2] &&
                  data[2]?.map((subData, j) => (
                    <div
                      key={j}
                      id={'ptcSubChildBox_' + data[3] + '_' + subData[0]}
                      className={
                        showHideChiled === data[3] + '_' + subData[0]
                          ? ''
                          : 'hide'
                      }
                      style={{ height: '100%' }}
                    >
                      <div className="sec-col-serch">
                        <span className="clear5 clear-left10">
                          <input
                            type="checkbox"
                            checked={
                              checkedAll[data[3] + '_' + subData[0]] || ''
                            }
                            onChange={(e) =>
                              selectAll(e, data[3] + '_' + subData[0])
                            }
                          />
                        </span>
                        <span className="clear-left10">
                          <input
                            type="search"
                            className="cnslng-fu-chld-srch"
                            placeholder="Search here..."
                            value={childSerch[data[3] + '_' + subData[0]] || ''}
                            onChange={(e) =>
                              handleChildSerch(e, data[3] + '_' + subData[0])
                            }
                          />
                          {editModeEnabled &&
                          subData[1] !== 'Current Problems' &&
                          data[4] !== 'medication' &&
                          data[4] !== 'diagnosis' ? (
                            <span
                              className="add-new-chld-item"
                              title="Add new values"
                              onClick={() => setAddSubChild(true)}
                            >
                              +
                            </span>
                          ) : (
                            ''
                          )}
                        </span>
                        {addSubChild && (
                          <AddSubValPopup
                            closeDialog={() => setAddSubChild(false)}
                            masCatId={data[3]}
                            masterId={subData[0]}
                            childId={''}
                            handleCalbackData={handleCalbackData}
                            catIndex={i}
                            subCatIndex={j}
                            formName="custom_counseling2"
                            heading={subData[1]}
                            providerId={allData?.soapDetail?.counsellor_id || 0}
                          />
                        )}
                        {/* {editSubChild.status && (
                          <AddSubValPopup
                            closeDialog={() =>
                              setEditSubChild({
                                ...editSubChild,
                                status: false,
                              })
                            }
                            masCatId={data[3]}
                            masterId={subData[0]}
                            childId={editSubChild?.data[2]}
                            handleCalbackData={handleCalbackData}
                            catIndex={i}
                            subCatIndex={j}
                            formName="custom_counseling2"
                            heading={subData[1]}
                            cat={editSubChild?.data[3]}
                          />
                        )} */}
                      </div>
                      {(() => {
                        if (
                          (data[1] === 'Problem' && allData?.probArr) ||
                          (data[4] === 'diagnosis' && allData?.probArr) ||
                          (data[1] === 'Active Diagnosis' && allData?.probArr)
                        ) {
                          return (
                            <CounselingSecColSubChildUnRegister
                              editModeEnabled={editModeEnabled}
                              providerId={allData?.soapDetail?.counsellor_id}
                              // soapId={soapId}
                              patientId={patientId}
                              visitId={visitId}
                              onReasonUpdate={
                                (probArr) =>
                                  dispatch(
                                    setAllDataTwo({
                                      ...allData,
                                      probArr: probArr,
                                    }),
                                  )
                                // setAllData((prev) => ({
                                //   ...prev,
                                //   probArr: probArr,
                                // }))
                              }
                              data={data}
                              subData={subData}
                              checkBoxData={checkBoxData}
                              handleCheckBoxChange={handleCheckBoxChange}
                              handleRemoveSubChild={handleRemoveSubChild}
                              moduleName={'ptc'}
                              allData={allData?.probArr}
                              checkboxRef={checkboxRef}
                              handleCheckBoxLable={handleCheckBoxLable}
                            />
                          );
                        } else if (
                          data[1] === 'Session' &&
                          allData?.golObjData
                        ) {
                          return (
                            <CounselingSecColSubChildUnRegister
                              editModeEnabled={editModeEnabled}
                              data={data}
                              subData={subData}
                              checkBoxData={checkBoxData}
                              handleCheckBoxChange={handleCheckBoxChange}
                              handleRemoveSubChild={handleRemoveSubChild}
                              moduleName={'ptc'}
                              allData={allData?.golObjData}
                              checkboxRef={checkboxRef}
                              handleCheckBoxLable={handleCheckBoxLable}
                            />
                          );
                        } else if (
                          data[1] === 'Medications' &&
                          allData?.activeMeds
                        ) {
                          return (
                            <CounselingSecColSubChildUnRegister
                              editModeEnabled={editModeEnabled}
                              data={data}
                              subData={subData}
                              checkBoxData={checkBoxData}
                              handleCheckBoxChange={handleCheckBoxChange}
                              handleRemoveSubChild={handleRemoveSubChild}
                              moduleName={'ptc'}
                              allData={allData?.activeMeds}
                              checkboxRef={checkboxRef}
                              handleCheckBoxLable={handleCheckBoxLable}
                            />
                          );
                        } else {
                          return (
                            <CounselingSecColSubChild
                              editModeEnabled={editModeEnabled}
                              data={data}
                              subData={subData}
                              checkBoxData={checkBoxData}
                              handleCheckBoxChange={handleCheckBoxChange}
                              handleRemoveSubChild={handleRemoveSubChild}
                              handleEditSubChild={(id) => {
                                handleEditSubChild(id);
                                setEditSubValPopupData({
                                  masCatId: data[3],
                                  masterId: subData[0],
                                  heading: subData[1],
                                  catIndex: i,
                                  subCatIndex: j,
                                });
                              }}
                              moduleName={'ptc'}
                              checkboxRef={checkboxRef}
                              handleCheckBoxLable={handleCheckBoxLable}
                              allData={allData}
                            />
                          );
                        }
                      })()}
                    </div>
                  ))}
              </div>
            ))}
          </div>
          <div className="mat-cnslng-col3">
            {allData?.therapyMasterData?.map((data, i) => (
              <div key={i}>
                {data[2]?.map((subData, j) => (
                  <div
                    key={j}
                    className="grid-sec"
                    ref={(el) =>
                      (scrollRefs.current[
                        'therapyDetailsText_' + data[3] + '_' + subData[0]
                      ] = el)
                    }
                  >
                    <span className="pop-up-sb-hdr">{subData[1]}</span>
                    <textarea
                      className="cnslng-poup-txtrea"
                      placeholder="Write here..."
                      id={'therapyDetailsText_' + data[3] + '_' + subData[0]}
                      name={'therapyDetailsText_' + data[3] + '_' + subData[0]}
                      spellCheck="true"
                      value={
                        textAreaData &&
                        textAreaData[
                          'therapyDetailsText_' + data[3] + '_' + subData[0]
                        ]
                      }
                      onChange={handleInputChange}
                    ></textarea>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        {editModeEnabled ? (
          <div className="gnrl-dtl-btn-rw">
            <button
              className="actn-No"
              onClick={() => setEditModeEnabled(false)}
            >
              Cancel
            </button>
          </div>
        ) : (
          <div className="gnrl-dtl-btn-rw flex gap-2">
            {(allData?.mode === 'add' && (
              <Button variant="primary" onClick={handleCounsellingFormSave}>
                Save
              </Button>
            )) ||
              (allData?.mode === 'update' && (
                <Button variant="primary" onClick={handleCounsellingFormUpdate}>
                  Update
                </Button>
              ))}

            <Button variant="outline" onClick={handleCloseFun}>
              Cancel
            </Button>
          </div>
        )}
        {editSubChild.status && (
          <AddSubValPopup
            closeDialog={() => {
              setEditSubChild({
                ...editSubChild,
                status: false,
              });
              setEditSubValPopupData(null);
            }}
            {...editSubValpopupData}
            childId={editSubChild?.data[2]}
            handleCalbackData={handleCalbackData}
            formName="custom_counseling2"
            cat={editSubChild?.data[3]}
            catSubType={editSubChild?.data[4]}
          />
        )}
        {removeSubChild && (
          <ConfirmDialog
            bodytext={'Do you want to remove it?'}
            closeDialog={() => setRemoveSubChild(false)}
            successDialog={handleRemoveSubChildConfirm}
            sucPrams={sucPrams}
          />
        )}
        {confirmEditableDialog && (
          <ConfirmDialog
            title="Edit form"
            bodytext={'Do you really want to open edit mode?'}
            closeDialog={() => setConfirmEditableDialog(false)}
            successDialog={() => setEditModeEnabled(true)}
          />
        )}
        {subTypePopup && (
          <SubTypePopup
            closeDialog={() => setSubTypePopup(false)}
            subChildPrams={subChildPrams}
            callBack={handlesubtypeform}
            form={'custom_counseling2'}
          />
        )}
        {cancelLable && (
          <AddCatagoryInCounsellingPopup
            cancelLable={() => {
              setCancelLable(false);
              setEditCategoryData({});
            }}
            editCategoryData={editCategoryData}
            providerId={allData?.soapDetail?.counsellor_id}
            setAllData={setAllDataTwo}
            allData={allData}
            type={'5'}
          />
        )}
        {cancelSubLable && (
          <AddSubCatagoryInCounsellingPopup
            cancelSubLable={() => {
              setCancelSubLable(false);
              setAddSubCategoryData({});
            }}
            addSubCategoryData={addSubCategoryData}
            providerId={allData?.soapDetail?.counsellor_id}
            setAllData={setAllDataTwo}
            allData={allData}
            type={'5'}
          />
        )}
        {confirmDelPopup.status && (
          <ConfirmDialog
            title="Category"
            bodytext={'Are you sure you want to delete this category?'}
            closeDialog={() => setConfirmDelPopup({ status: false, id: '' })}
            successDialog={handleDeleteCategoryConfirm}
            sucPrams={confirmDelPopup}
          />
        )}
        {confirmSubDelPopup.status && (
          <ConfirmDialog
            title="Sub Category"
            bodytext={'Are you sure you want to delete this sub category?'}
            closeDialog={() => setConfirmSubDelPopup({ status: false, id: '' })}
            successDialog={handleDeleteSubCategoryConfirm}
            sucPrams={confirmSubDelPopup}
          />
        )}
      </div>
    </div>
  );
}

export default CustomCounsellingTwoPopup;
